export const authFeatureKey = 'auth';

export interface State {
  roles: string[],
}
